// extracted by mini-css-extract-plugin
export default {"rating":"rB-z","numberOfStars":"sB-z","count":"tB-z","barGraphSpacing":"uB-z","barGraph":"vB-z"};